import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

// components
import Layout from "./Layout";

// pages
import Error from "../pages/error";
import Login from "../pages/login";
// context
import { useUserState } from "../context/UserContext";


export default function App() {
  // global
  var { isAuthenticated, isAdmin } = useUserState();

  return (
    <HashRouter>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/app/dashboard" />} />
        <Route
          exact
          path="/app"
          render={() => <Redirect to="/app/dashboard" />}
        />
        <PrivateRouteDashboard path="/app/dashboard" component={Layout} />
        <PrivateRouteUsers path="/app/users" component={Layout} isAdmin={isAdmin} />
        <PublicRoute path="/login" component={Login} />
        <Route component={Error} />
      </Switch>
    </HashRouter>
  );

  function PrivateRouteDashboard({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }
  function PrivateRouteUsers({ component, isAdmin, ...rest }) {
    // console.log(isAdmin)
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            isAdmin ? (
              React.createElement(component, props)
            ) : (
              <Redirect to="/app/dashboard" />
            )
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            <Redirect to="/app/dashboard" />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }
}
